import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 3.75h-5.7a3.3 3.3 0 0 0-3.3 3.3c0 4.95 9 4.95 9 9.9a3.3 3.3 0 0 1-3.3 3.3H7.5M12 3.75v-3m0 19.5v3"
    }, null, -1)
  ]));
}
const moneyCurrencyDollarPay = { render };
export {
  moneyCurrencyDollarPay as default,
  render
};
//# sourceMappingURL=money-currency-dollar-pay.svg.js.map
